import { CALENDAR_GRID_WEEK_GROUP_MORE_PREFIX } from './CalendarGridWeekGroupMore.constants'

export function getCalendarGridWeekGroupMoreLabel(moreCount) {
  return `${CALENDAR_GRID_WEEK_GROUP_MORE_PREFIX}${moreCount}`
}
